import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2cf478bc")
const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "ml-4 text-error text-caption" }
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = { class: "v-input__details" }
const _hoisted_5 = { class: "ml-4 text-error text-caption" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "text-subtitle" }
_popScopeId()

import { withDefaults, watch, ref } from 'vue'
import { required } from '@/lib/validation'
import { useField } from 'vee-validate'
import Enrichments from './components/Enrichments.vue'
import AddEnrichmentDialog from '@/components/Editor/Dialog/AddEnrichmentDialog/AddEnrichmentDialog.vue'
import { IEnrichment, IStepData } from '@/interfaces/hoppermation'
import RenderEngine from '@/lib/enums/RenderEngines'

interface IProps {
  updateNodeData?: (data: IStepData) => void
  details?: IStepData
}


export default /*#__PURE__*/_defineComponent({
  props: {
    updateNodeData: { type: Function, required: false, default: () => ({}) },
    details: { type: null, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { updateNodeData: (data: IStepData) => void, details: IStepData }


const enrichment = ref(props.details.enrichment)
const alreadySubscribedTemplateAlias = ref(props.details.alreadySubscribedTemplateAlias)
const { errorMessage: errorTemplateAlias, value: templateAlias } = useField('templateAlias', required, {
  initialValue: props.details.templateAlias
})
const { errorMessage: errorRenderEngine, value: renderEngine } = useField('renderEngine', required, {
  initialValue: props.details.renderEngine
})

watch(renderEngine, (renderEngine) => {
  props.updateNodeData({ renderEngine })
})
watch(templateAlias, (value) => {
  props.updateNodeData({ templateAlias: value })
})
watch(alreadySubscribedTemplateAlias, (value) => {
  props.updateNodeData({ alreadySubscribedTemplateAlias: value })
})

const removeEnrichment = (index: number): void => {
  if (enrichment.value) {
    enrichment.value.splice(index, 1)
    props.updateNodeData({ enrichment: enrichment.value })
  }
}

const addEnrichment = (data: IEnrichment): void => {
  if (enrichment.value) {
    enrichment.value.push(data)
    props.updateNodeData({ enrichment: enrichment.value })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          class: _normalizeClass(["row-max", _unref(errorTemplateAlias) ? 'mb-3' : ''])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  name: "templateAlias",
                  modelValue: _unref(templateAlias),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(templateAlias) ? templateAlias.value = $event : null)),
                  "persistent-hint": "",
                  label: _ctx.$t('details.subscribe.templateAlias.placeholder'),
                  hint: _ctx.$t('details.subscribe.templateAlias.hint'),
                  class: "mb-0"
                }, null, 8, ["modelValue", "label", "hint"]),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(errorTemplateAlias) ? _ctx.$t(_unref(errorTemplateAlias)) : ''), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_v_row, { class: "row-max" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  name: "alreadySubscribedTemplateAlias",
                  modelValue: alreadySubscribedTemplateAlias.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (alreadySubscribedTemplateAlias.value = $event)),
                  "persistent-hint": "",
                  label: _ctx.$t('details.subscribe.alreadySubscribedTemplateAlias.placeholder'),
                  hint: _ctx.$t('details.subscribe.alreadySubscribedTemplateAlias.hint'),
                  class: "mb-0"
                }, null, 8, ["modelValue", "label", "hint"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, {
          class: _normalizeClass(["row-max mt-4", _unref(errorRenderEngine) ? 'mb-3' : ''])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  class: "px-4 width-full select",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(renderEngine) ? renderEngine.value = $event : null))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RenderEngine), (renderEngine) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: renderEngine,
                      value: renderEngine,
                      selected: renderEngine === renderEngine
                    }, _toDisplayString(renderEngine), 9, _hoisted_3))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(renderEngine)]
                ]),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('details.email.renderEngine.placeholder')), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(errorRenderEngine) ? _ctx.$t(_unref(errorRenderEngine)) : ''), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('details.subscribe.enrichment.title')), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('details.subscribe.enrichment.desc')), 1),
        _createVNode(Enrichments, {
          items: enrichment.value,
          "remove-enrichment": removeEnrichment
        }, null, 8, ["items"]),
        _createVNode(AddEnrichmentDialog, { "add-enrichment": addEnrichment })
      ]),
      _: 1
    })
  ]))
}
}

})